var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconlinkedin = function SvgIconlinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.663 0C15.402 0 16 .598 16 1.337v13.326c0 .739-.598 1.337-1.337 1.337H1.337A1.336 1.336 0 010 14.663V1.337C0 .598.598 0 1.337 0h13.326zm-3.848 6c-1.127 0-1.901.495-2.25 1.072L8.5 7.19V6.1H6.333v7.667h2.334v-3.714c0-1.245.458-2.036 1.56-2.036.752 0 1.072.659 1.104 1.835l.002.201v3.714h2.334V9.532C13.667 7.246 13.12 6 10.815 6zM4.667 6H2.333v7.667h2.334V6zM3.5 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: "#A7A7A7"
  })));
};
export default SvgIconlinkedin;